import { Injectable } from '@angular/core';
import { SettingsService } from './settings.service';
import { NetworkConstants } from 'na-lib';
import { removeUndefinedValuesFromObject } from 'na-lib';
import { collection, deleteDoc, doc, getFirestore, setDoc, updateDoc, getDocs, query, where } from '@angular/fire/firestore';
import { FirestoreService } from './firestore.service';

@Injectable({
  providedIn: 'root'
})
export class InterfacesService {
  db = this.firestore.db//getFirestore()

  constructor(private settingsService: SettingsService,
    private firestore:FirestoreService) { }

  async createInterface(data):Promise<string>{
    return new Promise(async (resolve, reject) => {

      const docRef = doc( collection(this.db,NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$, NetworkConstants.COLLECTION_INTERFACES) )
      const newId = docRef.id

      let newInterface = removeUndefinedValuesFromObject(data)
      newInterface['creationDate'] = new Date()
      newInterface['timeStamp'] = new Date()
      newInterface['id'] = newId

      try{

        await setDoc( docRef, newInterface)
        resolve(newId)
        
      }catch (error) {
        reject(error)
      }
    })

  }



  updateInterface(data:any):Promise<void>{
    return new Promise(async (resolve, reject) => {
        
      try{
        removeUndefinedValuesFromObject(data)
        data['timeStamp']= new Date()

        const docRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$,NetworkConstants.COLLECTION_INTERFACES, data.id )
        await updateDoc( docRef, data)
        
        resolve()
      }catch(error){
        reject(error)
      }
    }) 
  }

  deleteInterface(interfaceId):Promise<void>{
    return new Promise(async (resolve, reject) => {
      try {
        const docRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$, NetworkConstants.COLLECTION_INTERFACES, interfaceId)
        const d  = await deleteDoc( docRef)

        resolve(d)
      } catch (error) {
        reject(error)  
        console.log(error)      
      } 
    })
  }
  deleteApiToken(tokenValue: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const tokensCol = collection(
          this.db,
          NetworkConstants.COLLECTION_CONTEXTS,
          this.settingsService.contextId$,
          NetworkConstants.COLLECTION_APITOKENS
        );

        const q = query(tokensCol, where('token', '==', tokenValue));
        const snapshot = await getDocs(q);

        if (snapshot.empty) {
          console.warn(`No API token found with value: ${tokenValue}`);
          resolve();
          return;
        }

        const deletePromises = snapshot.docs.map(docSnap => deleteDoc(docSnap.ref));
        await Promise.all(deletePromises);

        resolve();
      } catch (error) {
        console.error('Error deleting API token:', error);
        reject(error);
      }
    });
  }

}